import { forwardRef } from 'react';
import { Select as AntdSelect } from 'antd';
import type { SelectProps as AntdSelectProps } from 'antd/es/select';
import type { RefSelectProps } from 'antd/lib/select';
import { CaretDownOutlined, LoadingOutlined } from '@ant-design/icons';
import cn from 'classnames';

const { Option } = AntdSelect;

interface SelectProps<ValueType = any> extends Omit<AntdSelectProps<ValueType>, 'suffixIcon'> {
    loading?: boolean;
    className?: string;
}

const SelectBase = forwardRef<RefSelectProps, SelectProps>((props, ref) => {
    const { children, className = '', loading = false, ...otherProps } = props;
    const icon = loading ? <LoadingOutlined spin /> : <CaretDownOutlined />;

    return (
        <AntdSelect
            ref={ref}
            className={cn('mi', className)}
            classNames={{
                popup: 'mi',
            }}
            suffixIcon={icon}
            {...otherProps}
        >
            {children}
        </AntdSelect>
    );
});

SelectBase.displayName = 'Select';

// Properly type the Option component
const SelectWithOption = SelectBase as typeof SelectBase & {
    Option: typeof Option;
};

SelectWithOption.Option = Option;

export const Select = SelectWithOption;
